import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardEmbed } from '../../components/DashboardEmbed';
import { getDashboardUrlByRole, getDashboardTitle, getDashboardDescription } from '../../config/dashboards';

export const OperationsDashboard = ({ user }: { user: any }) => {
  const { t } = useTranslation();
  const role = user?.role;
  return (
    <div className="p-4 md:p-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white mb-1">{t('dashboard.operations_incidents')}</h1>
        <p className="text-gray-400 text-sm">Suivi et analyse des incidents · Intelligence prédictive des risques</p>
      </div>
      <div className="space-y-10">
        <DashboardEmbed title={getDashboardTitle('operations_incidents')} embedUrl={getDashboardUrlByRole(role,'operations_incidents')} description={getDashboardDescription('operations_incidents')} userRole={role}/>
        <DashboardEmbed title={getDashboardTitle('operations_risks')} embedUrl={getDashboardUrlByRole(role,'operations_risks')} description={getDashboardDescription('operations_risks')} userRole={role}/>
      </div>
    </div>
  );
};
